import AppLogo from "@/components/AppLogo";
import { ButtonSolid } from "@intrasys/core-ui";
import { useNavigate } from "react-router-dom";
import illustration from "@/assets/img/illustrations/undraw_air_support_re_nybl.svg";
interface ContactUsPageProps {
  handleCallback?: () => void;
}

const ContactUsPage = ({ handleCallback }: ContactUsPageProps) => {
  const navigate = useNavigate();
  return (
    <div className="grid min-h-screen place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <AppLogo className="mb-10 justify-center" />
      <div className="text-center">
        <p className="text-3xl font-semibold text-primary-600">Need help?</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl dark:text-white">
          Contact Admin
        </h1>
        <div className="mt-12 flex justify-center">
          <img src={illustration} className="h-60 w-60" />
        </div>
        <p className="mt-6 text-base leading-7 text-gray-600 dark:text-gray-500">
          Please contact your system administrator.
        </p>

        <div className="mt-10 flex items-center justify-center gap-x-6">
          <ButtonSolid
            label="Go back home"
            onClick={() => (handleCallback ? handleCallback() : navigate("/"))}
          />
          {/* <ButtonSolid label="Contact Support" variant={"alternative"} /> */}
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;
